<template>
  <div class="gc-product-kits">
    <div class="css-v2 gc-popup-form">
      <gc-form
        :formOptions="{
          gcLabelLocation: 'left',
        }"
        :formItems="getHeaderFormItems"
        :formHeight="105"
        :isNormal="true"
        :data-model="getHeaderFormDataModel"
        :formMode="baseView.mode"
        :validationGroup="'gc-product-kits-header-form'"
        :formTitle="'gc-popup'"
        :ref="'gc-product-kits-header-form'"
      ></gc-form>
    </div>

    <div class="details-data-grid">
      <dx-data-grid
        :columns="getColumns"
        :data-source="getDataSource"
        :columnChooser="{
          enabled: false,
        }"
        :searchPanel="{
          visible: false,
        }"
        ref="dx-data-grid-comp"
        :pager="{ visible: false }"
        :height="getGridHeight"
        :row-alternation-enabled="true"
        :selection="{
          mode: 'none',
        }"
        @editor-preparing="onEditorPreparing"
        @toolbar-preparing="onToolbarPreparing($event)"
        @row-removed="onRowRemoved"
        @saved="onSaved"
      >
        <DxEditing
          :allow-updating="baseView.mode != 'review'"
          :allow-deleting="baseView.mode != 'review'"
          mode="cell"
          :new-row-position="'last'"
          :use-icons="true"
          :changes="changes"
          :select-text-on-edit-start="true"
          :refreshMode="'reshape'"
        />
        <template #Decimal="{ data }">
          <GcDecimal :dataValue="data" :format="data.column.format" />
        </template>
      </dx-data-grid>
    </div>

    <div class="kit-totals-box kits-total-form">
      <gc-form
        :formOptions="{
          gcLabelLocation: 'left',
        }"
        :formItems="getTotalFormItems"
        :formHeight="160"
        :isNormal="true"
        :data-model="getTotalFormDataModel"
        :formMode="baseView.mode"
        :validationGroup="'gc-product-kits-total-form'"
        :formTitle="'gc-popup'"
        :ref="'gc-product-kits-total-form'"
      ></gc-form>
    </div>

    <!-- Product Search Popup  -->
    <GcPopUpSearchForItem
      v-if="searchForItem && searchForItem.visible"
      :setVisible="searchForItem.visible"
      :callBack="searchForItem.popUpCallBack"
      :baseView="baseView"
      :setLoading="showLoading"
      :productListQuery="
        searchForItem.productListQuery
          ? searchForItem.productListQuery
          : undefined
      "
      :productListColumns="
        searchForItem.columns ? searchForItem.columns : undefined
      "
      :productListItems="
        searchForItem.productListItems
          ? searchForItem.productListItems
          : undefined
      "
      :title="'Search Product'"
      :gridOptions="{
        options: {
          pageSize: 25,
        },
      }"
    />

    <GcPopupValidationSummary
      v-if="formsConfig"
      :showPopup.sync="formsConfig.validationSummaryVisible"
      :title="'Validation Errors'"
      :isXSmall="isXSmall"
      :items.sync="formsConfig.items"
      :onHidden="onHiddenGcPopupValidationSummary"
    ></GcPopupValidationSummary>
  </div>
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import DataGridMixin from "@/_mixins/data-grid.mixin";
import ColumnWidth from "../_helpers/data-grid/ColumnWidth";
import ArrayStore from "devextreme/data/array_store";
import { ProductPurchaseService } from "../_services/api/purchasing/product-purchase.service";
import { ProductKitComponentsService } from "../_services/api/products/product-kit-components.service";

const rowBase = {
  ID: 1,
  ProductCode: undefined,
  ProductDescription: undefined,
  UM: undefined,
  Quantity: 0,
  UnitCost: 0,
  UnitSell: 0,
  TotalCost: 0,
  TotalSell: 0,
};

export default {
  mixins: [RouteMixin, FormMixin, DataGridMixin],
  props: {
    contentHeight: {
      type: Number,
      default: undefined,
    },
    dataModel: {
      type: Object,
      default: () => {},
    },
    productKitDetails: {
      type: Object,
      default: () => {},
    },
    allowToSave: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      model: {
        Product: undefined,
        KitVersion: undefined,
        DateChanged: undefined,
        StocktakeMethod: undefined,
      },
      totalModel: {
        SumComponentCost: 0,
        KitStdCost: 0,
        SumComponentSell: 0,
        KitStdSell: 0,
        MarkupPrcnt: 0,
      },
      localDataSource: new ArrayStore({
        key: "ID",
        data: [],
      }),
      changes: [],
      updateFooter: 0,
      formLoaded: false,
      searchForItem: {},
      selectedProductData: [],
      checkValid: false,
    };
  },
  async created() {
    if (this.dataModel) this.model.Product = this.dataModel.Description1;
    this.formLoaded = true;

    if (this.baseView.mode != "create") {
      await ProductKitComponentsService.getProductKit(this.baseView.id).then(
        (res) => {
          if (res.data.value.length > 0) {
            var data = res.data.value[0];
            this.model.KitVersion = data.CurrentVersion;
            this.model.DateChanged = new Date(data.DateChanged);
            this.model.StocktakeMethod = data.StocktakeMethod;

            this.totalModel.KitStdCost = data.StandardCost;
            this.totalModel.KitStdSell = data.StandardSell;
          }
        }
      );
      await ProductKitComponentsService.getProductKitDetails(
        this.baseView.id,
        this.model.KitVersion
      ).then((res) => {
        if (res.data.value.length > 0) {
          var data = res.data.value;
          data.forEach((element, index) => {
            this.localDataSource.insert({
              ID: index,
              ProductCode: element.ProductCode,
              ProductDescription: element.Description,
              UM: element.UnitOfMeasure,
              Quantity: element.Qty,
              UnitCost: element.StandardCost,
              UnitSell: element.StandardSell,
              TotalCost: (element.StandardCost * element.Qty).roundNumber(2),
              TotalSell: (element.StandardSell * element.Qty).roundNumber(2),
            });

            this.totalModel.SumComponentCost =
              this.totalModel.SumComponentCost +
              (element.StandardCost * element.Qty).roundNumber(2);
            this.totalModel.SumComponentSell =
              this.totalModel.SumComponentSell +
              (element.StandardSell * element.Qty).roundNumber(2);
          });
        }
        this.calculateMarkupPrcnt();
      });

      if (this.baseView.mode == "edit") {
        this.addNewRow({}, false);
      }
      this.getDataGridInstance().refresh(true);
    } else {
      if (this.productKitDetails) {
        if (this.productKitDetails.detailModel) {
          this.productKitDetails.detailModel.forEach((element, index) => {
            element.ID = index;
            this.localDataSource.insert(element);
          });
        }
        if (this.productKitDetails.dataModel) {
          if (!this.model.Product)
            this.model.Product = this.productKitDetails.dataModel.Product;
          this.model.KitVersion = this.productKitDetails.dataModel.KitVersion;
          this.model.DateChanged = this.productKitDetails.dataModel.DateChanged;
          this.model.StocktakeMethod =
            this.productKitDetails.dataModel.StocktakeMethod;

          this.totalModel.SumComponentCost =
            this.productKitDetails.dataModel.SumComponentCost;
          this.totalModel.KitStdCost =
            this.productKitDetails.dataModel.KitStdCost;
          this.totalModel.SumComponentSell =
            this.productKitDetails.dataModel.SumComponentSell;
          this.totalModel.KitStdSell =
            this.productKitDetails.dataModel.KitStdSell;
          this.totalModel.MarkupPrcnt =
            this.productKitDetails.dataModel.MarkupPrcnt;
        }
        setTimeout(() => {
          // this.updateFooterValues();

          this.addNewRow({}, false);
        }, 25);
      } else {
        this.localDataSource.insert(rowBase);
        this.model.KitVersion = 1;
        this.model.DateChanged = new Date();
        this.model.StocktakeMethod = "Kit";
      }
    }
  },
  computed: {
    getHeaderFormDataModel() {
      return this.model;
    },
    getHeaderFormItems() {
      return [
        {
          itemType: "group",
          caption: "",
          colCount: 2,
          items: [
            {
              // screenField: "Product",
              dataField: "Product",
              editorOptions: {
                readOnly: true,
              },
            },
            {
              itemType: "group",
              caption: "",
              colCount: 2,
              items: [
                {
                  dataField: "KitVersion",
                  label: {
                    text: "Kit Version",
                  },
                  editorType: "dxNumberBox",
                  editorOptions: {
                    readOnly: true,
                  },
                },
                {
                  screenField: "DateIn",
                  dataField: "DateChanged",
                  label: {
                    text: "Date Changed",
                  },
                  editorOptions: {
                    readOnly: true,
                  },
                },
              ],
            },

            {
              screenField: "StockTakeMethod",
              dataField: "StocktakeMethod",
              label: {
                text: "Stocktake Method",
              },
              required: true,
              // editorType: "dxSelectBox",
              // editorOptions: {
              //   items: ["Kit", "Component"],
              // },
            },
          ],
        },
      ];
    },
    getColumns() {
      return this.parseGridColumns([
        // {
        //   screenField: "Product",
        //   gridDataField: "ProductCode",
        //   maxWidth: ColumnWidth.Name.width,
        // },
        {
          caption: "Product",
          dataField: "ProductCode",
          fixed: true,
          fixedPosition: "left",
          width: ColumnWidth.Code.width,
          maxWidth: ColumnWidth.Code.width,
          cssClass:
            this.baseView.mode != "review"
              ? "gc-editable-cell-color"
              : undefined,
          allowEditing: this.baseView.mode != "review",
          editorType: "dxSelectBox",
          editorOptions: {
            dataSource: ProductPurchaseService.dataSourceConfig("api/Product", {
              filter: this.getProductSearchFilter,
              select: [
                "Code",
                "Description1",
                "Description2",
                "Description3",
                "Inactive",
                "StandardCost",
                "StandardSell",
                "UnitOfMeasureCode",
                "IsBatchProduct",
              ],
              postProcess: (data) => {
                var items = [];
                data.forEach((element) => {
                  var item = this.localDataSource._array.find(
                    (x) => x.ProductCode == element.Code
                  );
                  if (!item) items.push(element);
                });
                return items;
              },
            }),
            onOpened: (e) => {
              e.component.beginUpdate();
              if (e.component.getDataSource()) {
                // e.component.getDataSource().filter(this.getProductSearchFilter);
                e.component.getDataSource().reload();
              }
              e.component.endUpdate();
            },
            displayExpr: "Code",
            valueExpr: "Code",
            searchTimeout: 10,
            searchEnabled: true,
            searchExpr: [
              "Code",
              "Description1",
              "Description2",
              "Description3",
              "Inactive",
            ],
            itemTemplate: (data) => {
              return ` <div class="custom-auto-complete" id="${data.Code}" >
                            <span class="auto-complete-primary">
                              ${data.Code}
                            </span>
                            <span class="record-secondary gc-grid-code">
                              ${data.Description1}
                            </span> 
                          </div>`;
            },
            dropDownOptions: {
              minWidth: 400,
            },
            valueChangeEvent: "itemclick",
            onFocusIn: (e) => {
              this.removeCellFocus();

              e.event.target.select();
              e.element.parentElement.classList.add("key-pad-focused-cell");
              e.component.open();
            },
            onItemClick: (e, lineData) => {
              this.focusOnEditableCell(lineData.rowIndex, "Quantity");
            },
            onSelectionChanged: (e) => {
              this.onProductCodeSelectionChanged(e);
            },
          },
          setCellValue: async (newData, value, currentRowData) => {
            newData.ProductCode = value;

            var item = this.selectedProductData.find((x) => x.Code == value);

            newData.ProductDescription = item.Description1;
            newData.UM = item.UnitOfMeasureCode;
            newData.UnitCost = item.StandardCost;
            newData.UnitSell = item.StandardSell;
            newData.Quantity = 0;
            this.localDataSource.update(currentRowData.ID, newData);

            if (!currentRowData.ProductCode) this.addNewRow({}, false);

            // var rowIndexs = [];
            // this.localDataSource._array.forEach((element) => {
            //   if (this.getDataGridInstance().getRowIndexByKey(element.ID) != -1)
            //     rowIndexs.push(
            //       this.getDataGridInstance().getRowIndexByKey(element.ID)
            //     );
            // });

            // if (rowIndexs.length > 0)
            //   this.getDataGridInstance().repaintRows(rowIndexs);

            // // console.log("rowIndexs", rowIndexs);
            // this.getDataGridInstance().refresh(true);

            // setTimeout(() => {
            //   this.getDataGridInstance().saveEditData();
            //   this.getDataGridInstance().refresh(true);
            // }, 100);

            return newData;
          },
        },
        {
          screenField: "ItemDescription",
          gridLabel: "Description",
          gridDataField: "ProductDescription",
          maxWidth: ColumnWidth.ProductOrAccount.width,
        },
        {
          screenField: "StockUM",
          gridDataField: "UM",
          gridLabel: "UM",
          maxWidth: ColumnWidth.UnitOfMeasure.width,
        },
        {
          screenField: "Quantity",
          gridDataField: "Quantity",
          cssClass:
            this.baseView.mode != "review"
              ? "gc-editable-cell-color"
              : undefined,
          maxWidth: ColumnWidth.Code.width,
          allowEditing: this.baseView.mode != "review",
          editorOptions: {
            onFocusIn: (e) => {
              this.removeCellFocus();

              e.event.target.select();
              e.element.parentElement.classList.add("key-pad-focused-cell");
            },
            min: 0,
          },
          setCellValue: async (newData, value, currentRowData) => {
            newData.Quantity = value;
            newData.TotalCost = (currentRowData.UnitCost * value).roundNumber(
              2
            );
            newData.TotalSell = (currentRowData.UnitSell * value).roundNumber(
              2
            );
            this.localDataSource.update(currentRowData.ID, newData).then(() => {
              this.updateFooterValues();
            });

            return newData;
          },
        },
        {
          screenField: "UnitCost",
          gridDataField: "UnitCost",
          gridLabel: "Unit Cost",
          maxWidth: ColumnWidth.Price2DecimalPoints.width,
          allowEditing: false,
        },
        {
          screenField: "UnitSell",
          gridDataField: "UnitSell",
          gridLabel: "Unit Sell",
          maxWidth: ColumnWidth.Price2DecimalPoints.width,
          allowEditing: false,
        },
        {
          screenField: "TotalCost",
          gridDataField: "TotalCost",
          gridLabel: "Total Cost",
          maxWidth: ColumnWidth.Price2DecimalPoints.width,
          allowEditing: false,
        },
        {
          screenField: "Total",
          gridDataField: "TotalSell",
          gridLabel: "Total Sell",
          maxWidth: ColumnWidth.Price2DecimalPoints.width,
          allowEditing: false,
        },
        {
          visible: this.baseView.mode != "review",
          caption: "",
          dataField: "",
          type: "buttons",
          alignment: "right",
          maxWidth: 50,
          buttons: [
            {
              hint: "Add",
              icon: "plus",
              onClick: async (e) => {
                this.addNewRowByPosition(e);
              },
            },
            "delete",
          ],
        },
      ]);
    },
    getDataSource() {
      return this.localDataSource;
    },
    getGridHeight() {
      return this.contentHeight
        ? this.contentHeight - 40 - 95 - 50 - 40 - 170
        : "auto";
      // 40 title height
      // 95 header form height
      // 50 extra paddings
      // footer height
      // 170 totals form height
    },
    getTotalFormDataModel() {
      return this.totalModel;
    },
    getTotalFormItems() {
      return [
        {
          itemType: "group",
          caption: "",
          colCount: 3,
          items: [
            {
              itemType: "group",
              caption: "",
              colCount: 1,
              items: [],
            },
            {
              itemType: "group",
              caption: "",
              colCount: 1,
              items: [],
            },
            {
              itemType: "group",
              caption: "",
              colCount: 1,
              items: [
                {
                  screenField: "Total",
                  dataField: "SumComponentCost",
                  label: {
                    text: "Sum Component Cost",
                  },
                  editorOptions: {
                    readOnly: true,
                  },
                },
                {
                  screenField: "Total",
                  dataField: "KitStdCost",
                  label: {
                    text: "Kit Std Cost",
                  },
                  editorOptions: {
                    min: 0,
                    onValueChanged: (e) => {
                      if (!e.event) return;
                      this.onKitStdCoseValueChanged(e);
                    },
                  },
                },
                {
                  screenField: "Total",
                  dataField: "SumComponentSell",
                  label: {
                    text: "Sum Component Sell",
                  },
                  editorOptions: {
                    readOnly: true,
                  },
                },
                {
                  screenField: "Total",
                  dataField: "KitStdSell",
                  label: {
                    text: "Kit Std Sell",
                  },
                  editorOptions: {
                    min: 0,
                    onValueChanged: (e) => {
                      if (!e.event) return;
                      this.onKitStdSellValueChanged(e);
                    },
                  },
                },
                {
                  screenField: "Total",
                  dataField: "MarkupPrcnt",
                  label: {
                    text: "Markup %",
                  },
                  editorOptions: {
                    readOnly: true,
                  },
                },
              ],
            },
          ],
        },
      ];
    },
    getProductSearchFilter() {
      var filter = [
        ["Status", "=", "A"],
        "and",
        ["Inactive", "=", "N"],
        "and",
        ["IsBatchProduct", "=", "No"],
      ];
      return filter;
    },
    getProductSearchModelFilter() {
      var filter = [
        ["Status", "=", "A"],
        "and",
        ["Inactive", "=", "N"],
        "and",
        ["IsBatchProduct", "=", "No"],
      ];
      if (this.localDataSource._array.length > 0) {
        var setFilter = [];
        this.localDataSource._array.forEach((element) => {
          if (element.ProductCode) {
            if (setFilter.length > 0) setFilter.push("and");
            setFilter.push(["Code", "<>", `${element.ProductCode}`]);
          }
        });

        if (setFilter.length > 0) {
          filter.push("and");
          filter.push(setFilter);
        }
        return filter;
      } else {
        return filter;
      }
    },
  },
  methods: {
    onProductCodeSelectionChanged(e) {
      if (
        this.selectedProductData.findIndex(
          (x) => x.Code == e.selectedItem.Code
        ) == -1
      )
        this.selectedProductData.push(e.selectedItem);
    },
    addNewRowByPosition(e) {
      var rowData = e.row;

      if (!rowData.data.ProductCode)
        this.displayValidationSummary([
          {
            message: `Product Code is required`,
          },
        ]);
      else if (!rowData.data.Quantity)
        this.displayValidationSummary([
          {
            message: `Quantity is required`,
          },
        ]);
      else {
        const maxID = Math.max.apply(
          Math,
          this.localDataSource._array.map(function (o) {
            return o.ID;
          })
        );
        var obj = { ...rowBase };
        obj.ID = maxID + 1;

        this.changes = [
          {
            type: "insert",
            data: obj,
            insertAfterKey: rowData.key,
          },
        ];

        setTimeout(() => {
          this.getDataGridInstance().saveEditData();
          this.getDataGridInstance().refresh(true);
        }, 100);
      }
    },
    onToolbarPreparing(e) {
      e.toolbarOptions.items.push({
        location: "before",
        widget: "dxButton",
        options: {
          icon: undefined,
          text: "Search",
          elementAttr: {
            class: "cx-color-button",
          },
          onClick: async () => {
            this.visibleProductSearch();
          },
          visible: this.baseView.mode != "review",
        },
      });
    },
    async visibleProductSearch() {
      this.searchForItem = {
        visible: true,
        popUpCallBack: this.visibleProductSearchCallBack,
        productListQuery: {
          endpoint: "Product",
          select: [
            "Code",
            "Description1",
            "Description2",
            "Description3",
            "Inactive",
            "StandardCost",
            "StandardSell",
            "UnitOfMeasureCode",
            "IsBatchProduct",
          ],
          filter: this.getProductSearchModelFilter,
          serverPaging: true,
          allowGrouping: false,
          // postProcessCallback: (data) => {
          //   var items = [];
          //   data.forEach((element) => {
          //     var item = this.localDataSource._array.find(
          //       (x) => x.ProductCode == element.Code
          //     );
          //     if (!item) items.push(element);
          //   });
          //   return items;
          // },
        },
        columns: [
          {
            screenField: "Comments",
            label: "Product",
            dataField: "Code",
          },
          {
            screenField: "Comments",
            label: "Description",
            dataField: "Description1",
          },
        ],
      };
    },
    async visibleProductSearchCallBack(productItem) {
      this.searchForItem = {
        visible: false,
        popUpCallBack: this.visibleProductSearchCallBack,
      };
      if (productItem) {
        var dataGrid = this.$refs["dx-data-grid-comp"].instance;

        var index = this.localDataSource._array.findIndex(
          (x) => !x.ProductCode
        );
        var obj = {
          ProductCode: productItem.Code,
          ProductDescription: productItem.Description1,
          UM: productItem.UnitOfMeasureCode,
          UnitCost: productItem.StandardCost,
          UnitSell: productItem.StandardSell,
        };

        if (index != -1) {
          var data = this.localDataSource._array[index];

          this.localDataSource.update(data.ID, obj);
          var rowIndex = dataGrid.getRowIndexByKey(data.ID);

          setTimeout(() => {
            this.focusOnEditableCell(rowIndex, "Quantity");
            this.addNewRow({}, false);
          }, 5);
        } else {
          this.addNewRow(obj, "Quantity");
        }
      }
    },
    addNewRow(obj, nextFocus) {
      const maxID = Math.max.apply(
        Math,
        this.localDataSource._array.map(function (o) {
          return o.ID;
        })
      );
      var dataObj = { ...rowBase, ...obj };

      if (maxID != -Infinity) dataObj.ID = maxID + 1;
      this.localDataSource.insert(dataObj);

      setTimeout(() => {
        this.getDataGridInstance()
          .refresh(true)
          .then(() => {
            if (nextFocus) {
              var rowIndex = this.getDataGridInstance().getRowIndexByKey(
                dataObj.ID
              );
              setTimeout(() => {
                this.focusOnEditableCell(rowIndex, nextFocus);
              }, 5);
            }
          });
      }, 10);
    },
    updateFooterValues() {
      this.updateFooter++;
    },
    onKitStdCoseValueChanged(e) {
      this.totalModel.KitStdCost = e.value;
      this.calculateMarkupPrcnt();
    },
    onKitStdSellValueChanged(e) {
      this.totalModel.KitStdSell = e.value;
      this.calculateMarkupPrcnt();
    },
    focusOnEditableCell(rowIndex, column) {
      if (rowIndex == -1) return;
      var columnName = column ? column : "Code";
      var dataGrid = this.$refs["dx-data-grid-comp"].instance;

      var cellElement = dataGrid.getCellElement(rowIndex, columnName);
      dataGrid.focus(cellElement);
      setTimeout(() => {
        dataGrid.editCell(rowIndex, columnName);
      }, 10);
    },
    onRowRemoved() {
      this.updateFooterValues();
    },
    onEditorPreparing(e) {
      if (e.editorOptions && e.editorOptions.onItemClick) {
        let func = e.editorOptions.onItemClick;
        if (this.baseView.mode != "review" && e.parentType != "searchPanel")
          e.editorOptions.onItemClick = (event) => {
            func(event, {
              column: {
                dataField: e.dataField,
              },
              data: e.row.data,
              rowIndex: e.row.rowIndex,
            });
          };
      }
    },
    onSaved(e) {
      if (e.changes && e.changes.length > 0) {
        var change = e.changes[0];
        if (change.insertAfterKey != undefined) {
          var element = change.data;
          var index = -1;

          index = this.localDataSource._array.findIndex(
            (x) => x.ID == change.insertAfterKey
          );
          this.localDataSource._array.splice(
            this.localDataSource._array.length - 1,
            1
          );
          this.localDataSource._array.splice(index + 1, 0, element);

          if (index != -1)
            setTimeout(() => {
              this.focusOnEditableCell(index + 1, "ProductCode");
            }, 100);
        }
      }
    },
    removeCellFocus() {
      var cell = document.querySelectorAll(".key-pad-focused-cell");
      if (cell.length > 0) cell[0].classList.remove("key-pad-focused-cell");
    },
    onHiddenGcPopupValidationSummary() {
      this.formsConfig.validationSummaryVisible = false;
    },
    getDataGridInstance() {
      return this.$refs["dx-data-grid-comp"].instance;
    },
    async getDataModels() {
      const mainForm = await this.$refs[
        "gc-product-kits-header-form"
      ].getFormValidations();

      if (mainForm.isValid == true) {
        return {
          dataModel: { ...this.model, ...this.totalModel },
          detailModel: this.localDataSource._array.filter((x) => x.ProductCode),
        };
      } else {
        this.displayValidationSummary(mainForm.brokenRules);
        return false;
      }
    },
    calculateMarkupPrcnt() {
      this.totalModel.MarkupPrcnt = (
        ((this.totalModel.KitStdSell - this.totalModel.KitStdCost) /
          this.totalModel.KitStdCost) *
        100
      ).roundNumber(2);

      if (
        isNaN(this.totalModel.MarkupPrcnt) ||
        this.totalModel.MarkupPrcnt === Infinity
      ) {
        this.totalModel.MarkupPrcnt = 0;
      }
    },
  },
  watch: {
    updateFooter() {
      this.totalModel.SumComponentCost = 0;
      this.totalModel.KitStdCost = 0;
      this.totalModel.SumComponentSell = 0;
      this.totalModel.KitStdSell = 0;
      this.totalModel.MarkupPrcnt = 0;
      this.localDataSource._array.forEach((element) => {
        this.totalModel.SumComponentCost =
          this.totalModel.SumComponentCost + element.TotalCost;

        this.totalModel.KitStdCost =
          this.totalModel.KitStdCost + element.TotalCost;
        this.totalModel.SumComponentSell =
          this.totalModel.SumComponentSell + element.TotalSell;
        this.totalModel.KitStdSell =
          this.totalModel.KitStdSell + element.TotalSell;
      });
      this.calculateMarkupPrcnt();

      if (this.totalModel.SumComponentCost != 0) this.allowToSave(true);
      else this.allowToSave(false);
    },
  },
  components: {},
};
</script>

<style lang="scss">
.gc-product-kits {
  .details-data-grid {
    padding: 0 10px 0 10px;
    .gc-editable-cell-color[role="gridcell"]:not(.cell-disabled) {
      background-color: #f8fdfe !important;
      // #d1f7ffba !important
    }
    .dx-datagrid .dx-row.dx-data-row.dx-row-lines .key-pad-focused-cell {
      background-color: #d1f7ffba !important;
    }
    .dx-datagrid
      .dx-datagrid-content
      .dx-datagrid-table
      .dx-row
      .dx-editor-cell {
      padding-left: 5px !important;
      padding-right: 5px !important;
    }
  }

  .kit-totals-box {
    padding: 10px 10px 0 10px;

    > div {
      background-color: white;
    }

    // .kits-total-form {
    .dx-form {
      .dx-item > div > .dx-field-item {
        padding-top: unset !important;
        padding-bottom: unset !important;
      }
    }
    // }
  }

  form {
    padding-bottom: 0px !important;
  }
}
</style>
